/**
 * WEB-2022 / WEB-2024 — язык СИСТЕМНЫХ текстов публичной страницы: аварийный
 * экран (`PublicErrorBoundary`), «страница недоступна» (отказ гейта тарифа,
 * `PublicHostRouter`). Это тексты покупателю, а покупатель говорит на языке
 * воронки (сторож WEB-967), не на языке кабинета — словарь кабинета
 * (`i18n/dictionaries/common`, только ru/en) здесь не участвует.
 *
 * Порядок: язык воронки, если страница её уже загрузила (страницы квиза и
 * пейволла кладут его сюда, как только знают), иначе — язык браузера
 * покупателя (`resolveVisitorLanguage`: явный `?lang`, запомненный выбор,
 * `navigator.languages`), иначе английский. Хранилище модульное, а не React-
 * контекст: граница падения стоит ВЫШЕ маршрутизатора (`public-main.tsx`) и
 * провайдер изнутри страницы до неё бы не дотянулся.
 */
import { resolveVisitorLanguage } from '@/utils/visitorLanguage';
import {
  getPublicQuizStrings,
  hasPublicQuizLocale,
  type PublicQuizStrings,
} from '@/utils/publicQuizStrings';

let funnelLanguage: string | null = null;

/** Страница воронки узнала язык загруженной воронки. Пустое значение не затирает язык браузера. */
export function setPublicFunnelLanguage(
  language: string | null | undefined,
): void {
  funnelLanguage = language && hasPublicQuizLocale(language) ? language : null;
}

/** Только для тестов — сброс к состоянию «воронка ещё не загружена». */
export function resetPublicFunnelLanguageForTests(): void {
  funnelLanguage = null;
}

function browserLanguage(): string | null {
  const visitor = resolveVisitorLanguage(null);
  if (visitor && hasPublicQuizLocale(visitor)) return visitor;
  if (typeof navigator === 'undefined') return null;
  const candidates = [
    ...(Array.isArray(navigator.languages) ? navigator.languages : []),
    navigator.language,
  ];
  return candidates.find((candidate) => hasPublicQuizLocale(candidate)) ?? null;
}

/** Словарь воронки для системных текстов публичной страницы (см. шапку). */
export function getPublicSystemStrings(): PublicQuizStrings {
  return getPublicQuizStrings(funnelLanguage ?? browserLanguage() ?? 'en');
}
